import {
  Box,
  Table,
  TableBody,
  TableHead,
  Grid,
  CardContent,
  Card,
  Divider,
} from "@mui/material";
import LabelTypography from "../Typography/LabelTypography";

import { StyledTableCell, StyledTableRow } from "../../assets/style/Table";
import { useTranslation } from "react-i18next";
import NumericFormatEnv from "../../components/Numeric/NumericFormatEnv";
import { Link } from "react-router-dom";

export default function BookingsTransactionPayment({
  bookings,
  listAffiche,
  typePayment,
}) {
  const { t } = useTranslation();
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ display: { xs: "none", md: "flex" } }}>
        <Box sx={{ width: "100%" }}>
          <Table sx={{ minWidth: 650 }} aria-label="checks table">
            <TableHead>
              <StyledTableRow>
                {listAffiche.includes("idBookings") && (
                  <StyledTableCell align="center">
                    {t("ID Booking")}
                  </StyledTableCell>
                )}
                {listAffiche.includes("idTransaction") && (
                  <StyledTableCell align="center">
                    {t("ID Transaction")}
                  </StyledTableCell>
                )}
                {listAffiche.includes("Montant") && (
                  <StyledTableCell align="center">
                    {t("Montant")}
                  </StyledTableCell>
                )}
                {listAffiche.includes("payment method") && (
                  <StyledTableCell align="center">
                    {" "}
                    {t("payment method")}
                  </StyledTableCell>
                )}
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {bookings?.map((p) => (
                <StyledTableRow key={p.booking_id}>
                  {listAffiche.includes("idBookings") && (
                    <StyledTableCell align="center">

                      {p.code}

                    </StyledTableCell>
                  )}
                  {listAffiche.includes("idTransaction") && (
                    <StyledTableCell align="center">
                      <Link to={`/DetaillTransaction/${p.transaction_id}`}>
                        #{p.transaction_id}
                      </Link>
                    </StyledTableCell>
                  )}
                  {listAffiche.includes("Montant") && (
                    <StyledTableCell align="center">
                      <NumericFormatEnv Number={parseFloat(p.montant_affecte, 0)} />
                    </StyledTableCell>
                  )}
                  {listAffiche.includes("payment method") && (
                    <StyledTableCell align="center">
                      {typePayment || p.payment_method}
                    </StyledTableCell>
                  )}
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Box>
      <Box sx={{ display: { xs: "flex", md: "none" } }}>
        <Grid container spacing={2}>
          {bookings?.map((p) => (
            <Grid item xs={12} key={p.id}>
              <Card
                variant="outlined"
                sx={{ maxWidth: 345, width: "95%", margin: "auto" }}
              >
                <CardContent>
                  <LabelTypography textAlign="center">
                    {t("ID Booking")} :{" "}

                    {p.code}

                  </LabelTypography>
                  <Divider sx={{ margin: "10px 0" }} />

                  <LabelTypography color="text.primary">
                    {t("ID Transaction")} :{" "}
                    <Link to={`/DetaillTransaction/${p.transaction_id}`}>
                      #{p.transaction_id}
                    </Link>
                  </LabelTypography>

                  <Divider sx={{ margin: "10px 0" }} />
                  <LabelTypography color="text.primary">
                    {t("Montant")} :{" "}
                    <NumericFormatEnv Number={parseFloat(p.montant_affecte, 0)} />
                  </LabelTypography>
                  <LabelTypography color="text.primary">
                    {t("payment method")}: {typePayment || p.payment_method}
                  </LabelTypography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
